var _title, _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgTutorialStartIcon = function SvgTutorialStartIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Menu/ Start")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Menu/-Start",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#B2B2B2",
    strokeWidth: 1.3,
    cx: 14,
    cy: 8,
    r: 5.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5,14.35 L15.5,14.35 C18.8965512,14.35 21.65,17.1034488 21.65,20.5 L21.65,24.65 L6.35,24.65 L6.35,20.5 C6.35,17.1034488 9.10344879,14.35 12.5,14.35 Z",
    id: "Rectangle",
    stroke: "#B2B2B2",
    strokeWidth: 1.3
  }))));
};

export default __webpack_public_path__ + "static/media/tutorial-start-icon.4380305b.svg";
export { SvgTutorialStartIcon as ReactComponent };